import { api } from '../services/api';
import { setAccessToken, clearAccessToken } from './authToken';
import { csrfHeaders, clearCsrfToken } from './csrf';

type RefreshResponse = {
  access_token: string;
  expires_in: number;
};

/** Restore session from httpOnly refresh cookie; returns false if unauthenticated. */
export async function restoreSessionFromCookie(): Promise<boolean> {
  try {
    const { data } = await api.post<RefreshResponse>(
      '/v1/auth/refresh',
      {},
      { headers: csrfHeaders() }
    );
    setAccessToken(data.access_token, data.expires_in);
    return true;
  } catch {
    clearAccessToken();
    clearCsrfToken();
    return false;
  }
}

/** Refresh access token using httpOnly cookie + CSRF header. */
export async function refreshAccessToken(): Promise<string | null> {
  try {
    const { data } = await api.post<RefreshResponse>(
      '/v1/auth/refresh',
      {},
      { headers: csrfHeaders() }
    );
    setAccessToken(data.access_token, data.expires_in);
    return data.access_token;
  } catch {
    clearAccessToken();
    clearCsrfToken();
    return null;
  }
}
